import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import SynchronizeButton from "../buttons/SynchronizeButton";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    isOpen: boolean
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 09/06/2022
 * @last_update 09/06/2022
 **/
class AlertTooManyAsync extends React.Component<Props> {

    state = {
        open: this.props.isOpen
    }

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        const handleClose = () => {
            this.setState({open: false});
        };

        return (

            <Dialog
                open={this.state.open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {getTranslation("utils.alert.too-many-async.title")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {getTranslation("utils.alert.too-many-async.content")}
                        <CloudSyncIcon/>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{getTranslation("utils.alert.too-many-async.close")}</Button>
                    <Button onClick={handleClose} autoFocus>
                        <SynchronizeButton synchronizeColor="primary"/>
                    </Button>
                </DialogActions>
            </Dialog>

        );

    };

}

export default withTranslation()(AlertTooManyAsync);
